import * as React from 'react';
import { useLocation } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import logo from './logo.png';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import '../../app/app.component.css';
import { useMediaQuery } from '@mui/material';

function CustomAppBar() {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMobile = useMediaQuery('(max-width:767px');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      style={{
        background: 'rgba(215, 236, 243, 0.5)', // Transparent background with the shade #D7ECF3
        backdropFilter: 'blur(10px)', // Adds blur effect
        borderRadius: isMobile ? '0 0 60px 60px' : '0 0 80px 80px' // Adjusted borderRadius for mobile and non-mobile
      }}
    >      <Toolbar style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className='logo'>
          <a href='/'><img style={{ height: '60px' }} src={logo} alt="Logo" /></a>
          <div className='mobile-buttons'>
            <Button style={{ color: '#496A86', backgroundColor: 'transparent' }} onClick={handleClick}>
              <MenuIcon />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}><Link className='app-link' to="/characters">CHARACTERS</Link></MenuItem>
              <MenuItem onClick={handleClose}><Link className='app-link' to="/pricing">PRICING</Link></MenuItem>
              <MenuItem onClick={handleClose}><Link className='app-link' to="/cast">CAST</Link></MenuItem>
              <MenuItem onClick={handleClose}><Link className='app-link' to="/contact">CONTACT</Link></MenuItem>
            </Menu>
          </div>
          {/* Buttons for desktop view */}
          <div className='app-buttons'>
            <button className={location.pathname === '/characters' ? 'app-button active' : 'app-button'}>
              <Link className={location.pathname === '/characters' ? 'app-button active-link' : 'app-button'} to="/characters">CHARACTERS</Link>
            </button>
            <button className={location.pathname === '/pricing' ? 'app-button active' : 'app-button'}>
              <Link className={location.pathname === '/pricing' ? 'app-button active-link' : 'app-button'} to="/pricing">PRICING</Link>
            </button>
            <button className={location.pathname === '/cast' ? 'app-button active' : 'app-button'}>
              <Link className={location.pathname === '/cast' ? 'app-button active-link' : 'app-button'} to="/cast">CAST</Link>
            </button>
            <button className={location.pathname === '/contact' ? 'app-button active' : 'app-button'}>
              <Link className={location.pathname === '/contact' ? 'app-button active-link' : 'app-button'} to="/contact">CONTACT</Link>
            </button>
          </div>
        </div>
        <div className='social-container'>
          <a href='https://www.instagram.com/royal_princess_parties' target='_blank'><InstagramIcon className='social-icons' /></a>
          <a href='https://twitter.com/parties_royal' target='_blank'><XIcon className='social-icons' /></a>
          <a href='https://www.facebook.com/rpp01' target='_blank'><FacebookIcon className='social-icons' /></a>
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default CustomAppBar;
